import { SchedulerV3 } from '@frontend/api-schedule-v3';
import { OPERTORIES_V3_SORT_BY, PageConfig } from '../../types';
import { useSchedulingLocationInfo } from '../use-scheduling-location-info';

type UseGetOperatoryV3DataParamsType = {
  selectedLocationId: string;
  selectedLocationIds: string[];
  debouncedSearchValue?: string;
  pageConfig?: PageConfig;
  isEnabled?: boolean;
};

export const useGetOperatoryV3Data = ({
  selectedLocationId,
  debouncedSearchValue,
  pageConfig,
  selectedLocationIds,
}: UseGetOperatoryV3DataParamsType) => {
  const { isScheduleV3FlagEnabled, isLoading: isLoadingFF } = SchedulerV3.Helpers.useGetSchedulerV3FeatureFlagDetails();
  const { isMultiLocation, parentLocationId } = useSchedulingLocationInfo();
  const isMultiLocationApiCall = !!parentLocationId && isMultiLocation;

  const listOperatoriesQuery = SchedulerV3.Queries.useListOperatoriesQuery({
    request: {
      locationId: selectedLocationId,
      ...(pageConfig?.limit && { limit: pageConfig?.limit }),
      ...(pageConfig?.page && { page: pageConfig?.page }),
      ...(debouncedSearchValue && { name: debouncedSearchValue }),
      ...(pageConfig?.sortBy &&
        pageConfig?.sortDir && {
          sort: { sortBy: OPERTORIES_V3_SORT_BY[pageConfig?.sortBy], sortDir: pageConfig?.sortDir },
        }),
    },
    options: {
      enabled: !isMultiLocationApiCall && !isLoadingFF && isScheduleV3FlagEnabled && !!selectedLocationId,
    },
  });

  const listOperatoriesMultiQuery = SchedulerV3.Queries.useListOperatoriesMultiQuery({
    request: {
      locationsIds: (selectedLocationIds || [selectedLocationId]).sort(),
      parentLocationId: parentLocationId || '',
      ...(pageConfig?.limit && { limit: pageConfig?.limit }),
      ...(pageConfig?.page && { page: pageConfig?.page }),
      ...(debouncedSearchValue && { name: debouncedSearchValue }),
      ...(pageConfig?.sortBy &&
        pageConfig?.sortDir && {
          sort: { sortBy: OPERTORIES_V3_SORT_BY[pageConfig?.sortBy], sortDir: pageConfig?.sortDir },
        }),
    },
    options: {
      enabled:
        isMultiLocationApiCall &&
        !isLoadingFF &&
        isScheduleV3FlagEnabled &&
        (!!selectedLocationIds?.length || !!selectedLocationId),
    },
  });

  return isMultiLocationApiCall ? listOperatoriesMultiQuery : listOperatoriesQuery;
};
